/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  View,
  KeyboardAvoidingView,
  findNodeHandle,
} from 'react-native';
import {
  Button,
  Input,
  CheckBox,
} from 'react-native-elements';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import { Auth } from '@aws-amplify/auth';

import AORTypes from '../../../types';
import styles from '../../../styles';
import { translate } from '../../../locales/i18n';
import ListPicker from '../../../components/misc/ListPicker';
import infraConfig from '../../../config.json';
import { language } from '../../../localization';

const validationSchema = yupObject().shape({
  // TODO(clairbee): refactor form validity, require the upstream and name here
});

class PublisherAdd extends React.Component {
  static async getToken() {
    const token = await Auth.currentSession()
      .then((response) => {
        console.log('got a token');
        return response.idToken.jwtToken;
      })
      .catch((error) => {
        console.log(error);
        return '';
      });

    return token;
  }

  constructor(props, context) {
    super(props, context);

    this.displayName = 'PublisherAdd';

    this.completion = this.completion.bind(this);
    this.completion = this.completion.bind(this);

    this.state = {
      upstreamId: null,
      doImport: false,
      completionResults: [],
      completionNeeded: false,
      confirmed: false,
    };
  }

  componentDidMount() {
  }

  completion(upstream, lang, name) {
    if (upstream === '') {
      this.setState({ completionResults: [] });
      return;
    }

    PublisherAdd.getToken()
      .then((token) => {
        console.log('fetching completion results');

        return fetch(encodeURI(`${infraConfig.indexApiUrl}/completion?upstream=${upstream}&lang=${lang}&prefix=${name}`), {
          method: 'GET',
          headers: {
            Publisherization: token,
            'Content-Type': 'application/json',
          },
        });
      })
      .then((result) => {
        console.log('completion success');
        console.log(result);

        return result.json();
      })
      .then((completionResults) => {
        console.log('completionResults');
        console.log(completionResults);

        this.setState({ completionResults });

        return true;
      })
      .catch((err) => {
        console.log('completion error');
        console.log(err);
        return false;
      });
  }

  importApp(upstream, upstreamId, lang) {
    const { history } = this.props;

    if (upstream === '' || upstreamId === '') {
      return;
    }

    PublisherAdd.getToken()
      .then((token) => {
        console.log('triggering app import');

        return fetch(encodeURI(`${infraConfig.indexApiUrl}/importApp?upstream=${upstream}&id=${upstreamId}&lang=${lang}`), {
          method: 'GET',
          headers: {
            Publisherization: token,
            'Content-Type': 'application/json',
          },
        });
      })
      .then((result) => {
        console.log('import success');
        console.log(result);

        return result.json();
      })
      .then((importResults) => {
        console.log('importResults');
        console.log(importResults);

        history.push(`/editapp/${importResults.uuid}`);

        return true;
      })
      .catch((err) => {
        console.log('import error');
        console.log(err);
        return false;
      });
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    // status,
  }) => {
    const {
      user,
      history,
      getAnalyticsService,
    } = this.props;
    const {
      doImport,
      completionResults,
      completionNeeded,
      confirmed,
      upstreamId,
    } = this.state;


    return (
      <View
        style={[
          styles.view.headless,
          {
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'center',
          },
        ]}
      >
        <KeyboardAvoidingView
          style={[
            styles.view.form,
            {
              backgroundColor: 'white',
              maxWidth: 600,
              width: '100%',
              padding: 0,
              margin: 0,
              alignItems: 'center',
            },
          ]}
          behavior="padding"
        >
          <KeyboardAwareScrollView
            style={{
              flex: 1,
              margin: 0,
            }}
            contentContainerStyle={{
              paddingBottom: 200,
              marginBottom: 200,
            }}
            enableAutomaticScroll={false}
            innerRef={(ref) => {
              this.scroll = ref;
            }}
          >
            <CheckBox
              center
              textStyle={styles.form.checkboxText}
              containerStyle={[styles.form.checkboxContainer,
              !doImport ? { backgroundColor: '#1FB5781C' } : {},
              ]}
              wrapperStyle={styles.form.wrapperStyle}
              title={translate('add_create')}
              onPress={() => {
                this.setState({ doImport: false });
              }}
              checked={!doImport}
              checkedIcon="check-circle"
              checkedColor="#1FB578"
              uncheckedIcon="circle"
              uncheckedColor="#F2F2F2"
              size={40}
            />

            <CheckBox
              center
              textStyle={styles.form.checkboxText}
              containerStyle={[styles.form.checkboxContainer,
              doImport ? { backgroundColor: '#1FB5781C' } : {},
              ]}
              wrapperStyle={styles.form.wrapperStyle}
              title={translate('add_import')}
              onPress={() => {
                this.setState({ doImport: true });
              }}
              checked={doImport}
              checkedIcon="check-circle"
              checkedColor="#1FB578"
              uncheckedIcon="circle"
              uncheckedColor="#F2F2F2"
              size={40}
            />

            {doImport && (
              <View
                style={{
                  alignSelf: 'center',
                  width: '100%',
                  // borderColor: 'red',
                  // borderWidth: 1,
                }}
              >
                <Input
                  containerStyle={[styles.form.inputContainer,
                  {
                    width: '100%',
                    // borderColor: 'red',
                    // borderWidth: 1,
                  },
                  ]}
                  labelStyle={styles.form.inputLabel}
                  inputStyle={styles.form.inputInput}
                  inputContainerStyle={[styles.form.inputInputContainer,
                  {
                    paddingHorizontal: 15,
                    paddingVertical: 10,
                    // borderColor: 'red',
                    // borderWidth: 1,
                  },
                  ]}
                  label={`${translate('add_app_upstream')}:`}
                  value={values.upstream}
                  onChange={(value) => setFieldValue('upstream', value)}
                  onBlur={() => setFieldTouched('upstream')}
                  errorMessage={touched.upstream && errors.upstream ? errors.upstream : undefined}
                  inputComponent={() => (
                    <ListPicker
                      style={{
                        flex: 1,
                        width: '100%',
                        backgroundColor: 'transparent',
                        paddingHorizontal: 0,
                        fontFamily: styles.primaryFont300,
                        fontWeight: '300',
                        fontSize: 14,
                      }}
                      value={values.upstream}
                      options={[{ label: translate('add_app_upstream_placeholder'), value: '' }, { label: 'izi.travel', value: 'izi.travel' }]}
                      onChange={(value) => {
                        setFieldValue('upstream', value);
                        this.completion(value, language(), values.app_name);
                        this.setState({ completionNeeded: true });
                      }}
                    />
                  )}
                />

                {/* TODO(clairbee): Add language selector here. */}

                {!!values.upstream && (
                  <Input
                    containerStyle={[styles.form.inputContainer,
                    { width: '100%' },
                    ]}
                    labelStyle={styles.form.inputLabel}
                    disabledInputStyle={styles.form.inputInputDisabled}
                    inputStyle={styles.form.inputInput}
                    inputContainerStyle={styles.form.inputInputContainer}
                    label={`${translate('add_app_name')}:`}
                    placeholder={translate('add_app_name_placeholder')}
                    value={values.app_name}
                    // importantForAutofill="no"
                    // textContentType="none"
                    // autoCompleteType="off"
                    autoComplete="off"
                    disabled={!doImport || values.upstream === ''}
                    onChangeText={(value) => {
                      setFieldValue('app_name', value);
                      this.completion(values.upstream, language(), value);
                      this.setState({ completionNeeded: true });
                    }}
                    onBlur={() => setFieldTouched('app_name')}
                    errorMessage={touched.app_name && errors.app_name ? errors.app_name : undefined}
                    onFocus={(event) => {
                      this.scroll.props.scrollToFocusedInput(findNodeHandle(event.target), 400);
                    }}
                  />
                )}
              </View>
            )}

            <View>
              <View
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  justifyContent: 'center',
                }}
              >
                {doImport && !!values.app_name && !!values.upstream && (
                  <CheckBox
                    center
                    textStyle={{
                      fontFamily: styles.primaryFont400,
                      fontWeight: '400',
                      fontSize: 14,
                      lineHeight: 28,
                    }}
                    containerStyle={[styles.form.checkboxContainer,
                    confirmed ? { backgroundColor: '#1FB5781C' } : {},
                    // { borderColor: 'red', borderWidth: 1 },
                    {
                      // width: '100%',
                      alignSelf: 'center',
                      alignContent: 'flex-start',
                      justifyContent: 'flex-start',
                    },
                    ]}
                    wrapperStyle={styles.form.wrapperStyle}
                    title={translate('add_import_owner')}
                    onPress={() => {
                      this.setState({ confirmed: !confirmed });
                    }}
                    disabled={(() => {
                      if (!doImport) {
                        return true;
                      }

                      if (!isValid || values.upstream === '' || values.app_name === '') {
                        return true;
                      }

                      if (upstreamId == null) {
                        return true;
                      }

                      return false;
                    })()}
                    checked={confirmed}
                    checkedIcon="check-circle"
                    checkedColor="#1FB578"
                    uncheckedIcon="circle"
                    uncheckedColor="#F2F2F2"
                    size={40}
                  />
                )}

                <Button
                  title={translate('button_continue')}
                  containerStyle={{
                    marginTop: 20,
                    alignSelf: 'center',
                  }}
                  buttonStyle={styles.button.primary}
                  disabledStyle={styles.button.primaryDisabled}
                  titleStyle={styles.button.primaryTitle}
                  disabledTitleStyle={styles.button.primaryTitleDisabled}
                  disabled={(() => {
                    if (!doImport) {
                      return false;
                    }

                    if (!isValid || values.upstream === '' || values.app_name === '') {
                      return true;
                    }

                    if (upstreamId == null) {
                      return true;
                    }

                    return !confirmed;
                  })()}
                  loading={isSubmitting}
                  onPress={() => {
                    if (!doImport) {
                      getAnalyticsService().report.event('create', 'create');
                      if (user && user.username) {
                        history.push('/addapp');
                      } else {
                        history.push('/signin/addapp');
                      }
                    } else {
                      handleSubmit();
                    }
                  }}
                />
              </View>
            </View>

            {doImport && (
              <View
                style={{
                  maxWidth: 600,
                  width: '100%',
                  alignSelf: 'center',
                }}
              >
                <View
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 10,
                    right: 10,
                    zIndex: 10,
                  }}
                >
                  {completionNeeded && completionResults && completionResults.map && completionResults.map((result) => (
                    <Text
                      style={{
                        borderWidth: 1,
                        borderStyle: 'solid',
                        borderColor: '#888',
                        fontSize: 18,
                        padding: 4,
                        backgroundColor: '#fff8cc',
                      }}
                      onPress={() => {
                        this.setState({
                          upstreamId: result[1],
                          completionNeeded: false,
                        });
                        setFieldValue('app_name', result[0]);
                      }}
                    >
                      {result[0]}
                    </Text>
                  ))}
                </View>
              </View>
            )}
          </KeyboardAwareScrollView>
        </KeyboardAvoidingView>
      </View>
    );
  }

  render() {
    const { getAnalyticsService } = this.props;
    const { upstreamId } = this.state;

    return (
      <Formik
        enableReinitialize
        initialValues={{ upstream: '', app_name: '' }}
        onSubmit={(values, _formikBag) => {
          getAnalyticsService().report.event('import', 'create');
          this.importApp(values.upstream, upstreamId, language());
        }}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

PublisherAdd.defaultProps = {
  user: null,
};

PublisherAdd.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  history: ReactRouterPropTypes.history.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
};

export default PublisherAdd;
